















































































































import { Component, Vue } from 'vue-property-decorator'
import { Audit } from '@/models'
import { Utils } from '@/utils'

@Component
export default class AccountAuditDetailModal extends Vue {
  private audit: Audit | null = null
  private changedFields: any = {}
  private showFullJson = false

  get hasChangedFields(): boolean {
    return Object.keys(this.changedFields).length > 0
  }

  show(audit: Audit) {
    this.audit = audit
    this.showFullJson = false
    this.calculateChangedFields()
    const modal = this.$refs.modal as any
    if (modal) {
      modal.show()
    }
  }

  hide() {
    const modal = this.$refs.modal as any
    if (modal) {
      modal.hide()
    }
  }

  onHidden() {
    this.audit = null
    this.changedFields = {}
  }

  calculateChangedFields() {
    if (!this.audit) return

    // Exclude fields that are not relevant to show to the user
    const excludeFields = ['updatedOn', 'synchronizedOn', 'createdOn']

    // Use Utils.compareJSON to identify changed fields
    const allChanges = Utils.compareJSON(
      this.audit.oldValue || {},
      this.audit.newValue || {}
    )

    // Filter out excluded fields
    this.changedFields = {}
    Object.keys(allChanges).forEach(key => {
      if (!excludeFields.includes(key)) {
        this.changedFields[key] = allChanges[key]
      }
    })
  }

  getOldValue(key: string): any {
    if (!this.audit || !this.audit.oldValue) return null
    return (this.audit.oldValue as any)[key]
  }

  formatValue(value: any): string {
    if (value === null || value === undefined) {
      return 'null'
    }
    if (typeof value === 'object') {
      return JSON.stringify(value, null, 2)
    }
    return String(value)
  }

  getModelVariant(modelKt: string): string {
    const variants: { [key: string]: string } = {
      Account: 'info',
      Permission: 'primary',
      AccountActions: 'warning',
      AccountManager: 'success'
    }
    return variants[modelKt] || 'secondary'
  }

  getModelLabel(modelKt: string): string {
    const labels: { [key: string]: string } = {
      Account: this.$t('account_detail.audit.type_account').toString(),
      Permission: this.$t('account_detail.audit.type_permission').toString(),
      AccountActions: this.$t('account_detail.audit.type_actions').toString(),
      AccountManager: this.$t('account_detail.audit.type_manager').toString()
    }
    return labels[modelKt] || modelKt
  }

  getChangeType(): string {
    if (!this.audit) return ''

    const labels: { [key: string]: string } = {
      INSERT: this.$t('account_detail.audit_detail.change_type_insert').toString(),
      UPDATE: this.$t('account_detail.audit_detail.change_type_update').toString(),
      DELETE: this.$t('account_detail.audit_detail.change_type_delete').toString()
    }
    return labels[this.audit.operationType] || this.audit.operationType
  }

  getChangeTypeVariant(): string {
    if (!this.audit) return 'secondary'

    const variants: { [key: string]: string } = {
      INSERT: 'success',
      UPDATE: 'info',
      DELETE: 'danger'
    }
    return variants[this.audit.operationType] || 'secondary'
  }
}
